import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Tabs } from 'antd';
import { Link } from 'react-router-dom';
import { errorMessage } from '../../MarketExplorer/api';
import { fetchCorpus } from './api';
import { CorpusState } from './types';
import CorpusControl from './CorpusControl';
import NewsBrowser from './NewsBrowser';
import Processing from './Processing';
import '../../MarketExplorer/styles.css';
import '../../MarketExplorer/workbench.css';
import './styles.css';

const CorpusNews: React.FC<{ onOpenJob: (id: string) => void }> = ({
  onOpenJob,
}) => {
  const [snapshot, setSnapshot] = useState<CorpusState | null>(null);
  const [error, setError] = useState('');
  const mounted = useRef(true);
  const inFlight = useRef(false);
  const refresh = useCallback(async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    try {
      const value = await fetchCorpus();
      if (mounted.current) {
        setSnapshot(value);
        setError('');
      }
    } catch (reason) {
      if (mounted.current) setError(errorMessage(reason));
    } finally {
      inFlight.current = false;
    }
  }, []);
  useEffect(() => {
    mounted.current = true;
    void refresh();
    return () => {
      mounted.current = false;
    };
  }, [refresh]);
  const moving =
    snapshot?.state === 'waking' ||
    snapshot?.state === 'draining' ||
    Boolean(snapshot?.active_jobs) ||
    Boolean(snapshot?.pending_jobs);
  useEffect(() => {
    const timer = window.setInterval(
      () => {
        if (!document.hidden) void refresh();
      },
      moving ? 3000 : 30000,
    );
    return () => window.clearInterval(timer);
  }, [moving, refresh]);
  return (
    <div className="corpus-news">
      <div className="corpus-news__intro">
        <div>
          <h2>Corpus & news</h2>
          <p>
            Find, improve and tag news. Review corpus suggestions before
            applying changes.
          </p>
        </div>
        <Link to="/dashboard/market-explorer">Open Market Explorer</Link>
      </div>
      <CorpusControl
        snapshot={snapshot}
        error={error}
        onChange={value => {
          setSnapshot(value);
          setError('');
        }}
        onRefresh={refresh}
      />
      <Tabs
        items={[
          { key: 'news', label: 'PM news', children: <NewsBrowser /> },
          {
            key: 'processing',
            label: 'Processing & proposals',
            children: (
              <Processing
                snapshot={snapshot}
                onOpenJob={onOpenJob}
                onWorkChanged={refresh}
              />
            ),
          },
        ]}
      />
    </div>
  );
};
export default CorpusNews;
